import * as types from '@/store/mutation-types';
import axios from '@/axios.js';

export default {
	namespaced: true,
	state: {
		classes: [],
		classesData: []
	},
	actions: {
		fetchAll ({ commit }) {
			return axios.get('/course/specialies/brief', { once: true }).then(({ data }) => {
				commit(types.STORE_CLASSES, data);
				return data;
			})
		},

		fetchClassData({ dispatch }, { classId }) {
			return Promise.all([
				dispatch('fetchCoursesByClassId', { classId }),
				dispatch('fetchConceptsByClassId', { classId }),
			]).then(([courses, concepts]) => ({ courses, concepts }))
		},
		
		fetchCoursesByClassId ({ commit, state }, { classId }) {
			const classIndex = state.classesData.findIndex(c => c.classId === classId);
			if (classIndex === -1) {
				return axios.get(`/course/brief/${classId}`).then(({ data }) => {
					commit(types.STORE_CLASS_COURSES, { classId, courses: data });
					return data;
				})
			} else {
				return new Promise((resolve) => {
					resolve(state.classesData[classIndex].courses);
				})
			}
		},
		fetchConceptsByClassId ({ commit, state }, { classId }) {
			const classIndex = state.classesData.findIndex(c => c.classId === classId);
			if (classIndex === -1) {
				return axios.get('/examTest/brief', {
					params: { specialtyId: classId }
				}).then(({ data }) => {
					commit(types.STORE_CLASS_CONCEPTS, { classId, concepts: data });
					return data;
				})
			} else {
				return new Promise((resolve) => {
					resolve(state.classesData[classIndex].concepts);
				})
			}
		},
	},
	mutations: {
		[types.STORE_CLASSES] (state, classes) {
			state.classes = classes;
		},
		[types.STORE_CLASS_COURSES] (state, { classId, courses }) {
			const index = state.classesData.findIndex(c => c.classId === classId);
			if (index === -1) {
				state.classesData.push({ classId, courses, concepts: [] });
			} else {
				state.classesData[index].courses = courses;
			}
		},
		[types.STORE_CLASS_CONCEPTS] (state, { classId, concepts }) {
			const index = state.classesData.findIndex(c => c.classId === classId);
			if (index === -1) {
				state.classesData.push({ classId, courses: [], concepts });
			} else {
				state.classesData[index].concepts = concepts;
			}
		},
	},
	getters: {
		getClassById: state => id => state.classes.find(c => c.id === id),
		getCourseById: state => id => state.classesData.flatMap(c => c.courses).find(c => c.id === id),
		getConceptById: state => id => state.classesData.flatMap(c => c.concepts).find(c => c.id === id),
	}
}